document.addEventListener("DOMContentLoaded", function () {
  const inputFields = document.querySelectorAll("#zipcode_and_city");

  if (inputFields.length === 0) return;

  inputFields.forEach((inputField) => {
    const dropdown = inputField
      .closest(".form-group")
      .querySelector(".form-group__dropdownSelector");
    const cityList = dropdown.querySelector(
      ".form-group__dropdownSelector__city-list"
    );
    let selectedIndex = -1;

    if (!dropdown || !cityList) return;

    inputField.addEventListener("focus", async (event) => {
      dropdown.classList.add("show");
      await searchTerm(inputField, cityList);
      event.stopPropagation();
    });

    inputField.addEventListener("click", async () => {
      dropdown.classList.add("show");
      await searchTerm(inputField, cityList);
    });

    inputField.addEventListener("blur", (event) => {
      setTimeout(() => {
        if (!dropdown.contains(document.activeElement)) {
          dropdown.classList.remove("show");
        }
      }, 200);
      event.stopPropagation();
    });

    inputField.addEventListener("input", async function () {
      await searchTerm(inputField, cityList);
    });

    cityList.addEventListener("click", (event) => {
      const listItem = event.target.closest("li");

      if (
        listItem &&
        listItem.querySelector("span") &&
        !listItem.classList.contains("invalid-result")
      ) {
        inputField.value = listItem.textContent.trim();
        dropdown.classList.remove("show");
      }
    });

    inputField.addEventListener("keydown", (event) => {
      const items = cityList.querySelectorAll("li:not(.invalid-result)"); // Ignorira invalidne rezultate
      if (items.length === 0) return;

      if (event.key === "ArrowDown") {
        event.preventDefault();
        selectedIndex = (selectedIndex + 1) % items.length;
        highlightSelected(items);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        selectedIndex = (selectedIndex - 1 + items.length) % items.length;
        highlightSelected(items);
      } else if (event.key === "Enter") {
        event.preventDefault();
        if (selectedIndex >= 0) {
          inputField.value = items[selectedIndex].textContent.trim();
        } else if (items.length > 0) {
          inputField.value = items[0].textContent.trim();
        }
        dropdown.classList.remove("show");
      }
    });

    const highlightSelected = (items) => {
      items.forEach((item, index) => {
        item.classList.toggle("selected", index === selectedIndex);
      });
    };
  });

  async function searchTerm(inputField, cityList) {
    const query = inputField.value.toLowerCase().trim();
    if (query.length < 3) {
      cityList.innerHTML = `<li class="form-group__dropdownSelector__city-list__city invalid-result">Potrebno upisati još znakova (${
        3 - query.length
      }).</li>`;
    } else {
      try {
        const response = await fetch(
          `/checkout/delivery_areas?search_term=${encodeURIComponent(query)}`
        );
        const data = await response.json();

        if (data.length > 0) {
          cityList.innerHTML = data
            .map(
              (zip_code) =>
                `<li class="form-group__dropdownSelector__city-list__city"><span>${zip_code}</span></li>`
            )
            .join("");
        } else {
          cityList.innerHTML =
            '<li class="form-group__dropdownSelector__city-list__city invalid-result">Nema rezultata</li>';
        }
      } catch {
        cityList.innerHTML =
          '<li class="form-group__dropdownSelector__city-list__city invalid-result">Nešto je pošlo po zlu.</li>';
      }
    }
  }
});
